import React, { Component } from 'react'

class ImageStrip extends Component {
    render() {
        const { images, activeImageIndex, onSelectImage, onAddImage, onRemoveImage, onMoveImage } = this.props

        return (
            <div className="image-strip">
                {images.map((image, i) => (
                    <div
                        key={i}
                        className={`image-strip__item${activeImageIndex === i ? ' image-strip__item--active' : ''}`}
                        onClick={() => onSelectImage(i)}>
                        <div className="image-strip__drag-handle" title="Verschieben">⠿</div>
                        <div className="image-strip__thumb">
                            <span className="image-strip__index text-xsmall-light">{i + 1}</span>
                        </div>
                        {images.length > 1 && (
                            <button className="image-strip__remove" title="Entfernen"
                                onClick={e => { e.stopPropagation(); onRemoveImage(i) }}>×</button>
                        )}
                    </div>
                ))}
                <button className="image-strip__add" onClick={onAddImage} title="Bild hinzufügen">
                    +
                </button>
            </div>
        )
    }
}

export default ImageStrip
